import { Dispatch } from 'redux'
import {
  apiRequest,
  apiFailure,
  getDepartments as getDepartmentsReducer,
  getDepartmentDetails as getDepartmentDetailsReducer,
  clearDepartmentDetails as clearDepartmentDetailsReducer,
} from 'reducers/department.reducer'
import { departmentService } from 'services/department.service'

export const getDepartments = () => async (dispatch: Dispatch) => {
  try {
    dispatch(apiRequest())

    const response = await departmentService.getDepartments()
    if (response) {
      const departmentsData = response

      dispatch(getDepartmentsReducer({ departmentsData }))
    }
  } catch (error) {
    console.error(error)
    dispatch(apiFailure())
  }
}

export const getDepartmentDetails =
  (slug: string) => async (dispatch: Dispatch) => {
    try {
      dispatch(apiRequest())

      const response = await departmentService.getDepartmentDetails(slug)
      if (response) {
        const departmentDetails = response

        dispatch(getDepartmentDetailsReducer({ departmentDetails }))
      }
    } catch (error) {
      console.error(error)
      dispatch(apiFailure())
    }
  }

export const clearDepartmentDetails = () => (dispatch: Dispatch) => {
  try {
    dispatch(clearDepartmentDetailsReducer())
  } catch (error) {
    console.error(`Could not clear department details state: ${error}`)
  }
}
